var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hospitalList"},[_c('van-nav-bar',{attrs:{"title":"选择医院","left-arrow":"","left-text":"返回"},on:{"click-left":_vm.goBackBlood}}),_c('hospital-piece',{attrs:{"comePath":_vm.comePath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }